import { I18n } from 'react-redux-i18n';
import {
  forwardingFormat,
  ForwardingFormat
} from '../../constants/forwardingFormat';
import notificationEntity from '../../constants/notificationEntity';
import notificationEventType from '../../constants/notificationEventType';

export const notificationEntityOptions = [
  {
    value: notificationEntity.organization,
    text: 'Organisation',
    locale: 'Organization'
  },
  {
    value: notificationEntity.campaign,
    text: 'Campaign'
  },
  {
    value: notificationEntity.team,
    text: 'Team'
  },
  {
    value: notificationEntity.fundraiser,
    text: 'Fundraiser'
  },
  {
    value: notificationEntity.event,
    text: 'Event'
  },
  {
    value: notificationEntity.donation,
    text: 'Donation'
  },
  {
    value: notificationEntity.session,
    text: 'Session'
  },
  {
    value: notificationEntity.accessKey,
    text: 'Access Key'
  },
  {
    value: notificationEntity.microblog,
    text: 'Microblog'
  },
  {
    value: notificationEntity.ticket,
    text: 'Ticket'
  },
  {
    value: notificationEntity.sale,
    text: 'Sale'
  },
  {
    value: notificationEntity.merchandise,
    text: 'Merchandise'
  },
  {
    value: notificationEntity.account,
    text: 'Account'
  },
  {
    value: notificationEntity.collection,
    text: 'Superteam'
  },
  {
    value: notificationEntity.donationSubscription,
    text: 'Donation Subscription'
  },
  {
    value: notificationEntity.fitnessActivity,
    text: 'Fitness Activity'
  },
  {
    value: notificationEntity.fitnessPlatformLink,
    text: 'Fitness Platform Link'
  },
  {
    value: notificationEntity.customActivity,
    text: 'Custom Activity'
  },
  {
    value: notificationEntity.eventAmbassador,
    text: 'Event Ambassador'
  },
  {
    value: notificationEntity.eventAmbassadorProgram,
    text: 'Event Ambassador Program'
  },
  {
    value: notificationEntity.campaignAmbassadorProgram,
    text: 'Campaign Ambassador Program'
  },
  {
    value: notificationEntity.eventOrganizer,
    text: 'Event Organiser',
    locale: 'Event Organizer'
  }
];

export const notificationEventTypeOptions = [
  {
    value: notificationEventType.created,
    text: 'Created'
  },
  {
    value: notificationEventType.deleted,
    text: 'Deleted'
  },
  {
    value: notificationEventType.updated,
    text: 'Updated'
  }
];

const formatLabelPath = 'webhooks.page.input.format-options';

export const forwardingFormatLabelKeys: Record<ForwardingFormat, string> = {
  [forwardingFormat.jsonDefault]: `${formatLabelPath}.json-default`,
  [forwardingFormat.jsonEnumAsInt]: `${formatLabelPath}.json-enum-as-int`,
  [forwardingFormat.jsonDefaultUtc]: `${formatLabelPath}.json-default-utc`
};

export interface ForwardingFormatOption {
  value: ForwardingFormat;
  text: string;
  disabled?: boolean;
  /** Offered because of system-level credentials; the dropdown marks the row. */
  systemOnly?: boolean;
}

/** The UTC format is offered to system admins only; an org admin editing a
 * row already on it sees it locked rather than a blank control. */
export const getForwardingFormatOptions = (
  isSystemAdmin: boolean,
  currentValue?: ForwardingFormat
): ForwardingFormatOption[] => {
  const options: ForwardingFormatOption[] = [
    {
      value: forwardingFormat.jsonDefault,
      text: I18n.t(forwardingFormatLabelKeys.jsonDefault)
    },
    {
      value: forwardingFormat.jsonEnumAsInt,
      text: I18n.t(forwardingFormatLabelKeys.jsonEnumAsInt)
    }
  ];
  if (isSystemAdmin) {
    options.push({
      value: forwardingFormat.jsonDefaultUtc,
      text: I18n.t(forwardingFormatLabelKeys.jsonDefaultUtc),
      systemOnly: true
    });
  } else if (currentValue === forwardingFormat.jsonDefaultUtc) {
    options.push({
      value: forwardingFormat.jsonDefaultUtc,
      text: I18n.t(forwardingFormatLabelKeys.jsonDefaultUtc),
      disabled: true
    });
  }
  return options;
};

export const getForwardingFormatText = (value: string) => {
  const key = forwardingFormatLabelKeys[value as ForwardingFormat];
  return key ? I18n.t(key) : value;
};
